module.exports = __webpack_public_path__ + "img/8b995eb.png";